import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import { Container, Row, Col, Button, Jumbotron, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import InfiniteScroll from 'react-infinite-scroller';
import pluralize from "pluralize";
import {
  isGamedistributionApp
} from "~/utils/misc";

import LinkComponent from "~/components/LinkComponent";
import { getCookie } from "~/utils/cookie";
import assetPath from "~/utils/assetPath";
import {
  pictureContainer
} from "./helpers/elements";

import styles from "./styles.scss";

class TopicsComponent extends React.Component {
  static propTypes = {
    id: PropTypes.string
  }
  static contextTypes = {
    fetch: PropTypes.func.isRequired
  };

  constructor(props) {
    // Set props
    super(props);

    // Set initial state
    this.state = {
      topics: [
        { title: "All", id: "all", active: true },
        { title: "Animal", id: "animals" },
        { title: "History", id: "history" },
        { title: "Travel", id: "travel" },
        { title: "Textures & pattern", id: "textures-patterns" },
        { title: "Nature", id: "nature" },
        { title: "Arts & culture", id: "arts-culture" },
        { title: "Food & drink", id: "food-drink" },
        { title: "Athletics", id: "athletics" },
        { title: "Architecture", id: "architecture" },
        { title: "People", id: "people" },
        { title: "Spirituality", id: "spirituality" },
        { title: "Experimental", id: "experimental" },
        { title: "Interiors", id: "interiors" },
        { title: "Street photography", id: "street-photography" },
        { title: "Wallpaper", id: "wallpapers" },
        { title: "Business & Work", id: "business-work" },
        { title: "Fashion", id: "fashion" },
        { title: "Film", id: "film" },
        { title: "Health & wellness", id: "health" },
        { title: "Technology", id: "technology" },
      ],
      sort: [
        { title: "Popularity", id: "popular", active: true },
        { title: "Newest", id: "latest" },
        { title: "Oldest", id: "oldest" },
      ],
      isLoadingPictures: false,
      hasMorePictures: !!props.id,
      picturePage: 1,
      pictures: [],
      topic: {},
      offsetRight: 0
    };
    if (!!props.id) this.state.topics = this.state.topics.map(topic => ({ ...topic, active: props.id == topic.id }))

    // Bind element functions
    this.pictureContainer = pictureContainer.bind(this);
  }

  //-----------------------------------------------------------------------
  // Lifecycle
  //-----------------------------------------------------------------------
  componentDidMount() {
    console.log("TopicsComponent")
    $(".dropdown-menu").perfectScrollbar({ suppressScrollX: true });

    this.loadTopic()
    this.loadPictures()
  }

  shouldComponentUpdate() {
    return false;
  }

  //-----------------------------------------------------------------------
  // Handlers
  //-----------------------------------------------------------------------
  handleBottomReached = () => {
    if (!!this.props.id) this.loadPictures()
  };

  handleTopicClicked = (topicID) => {
    let topics = this.state.topics;
    _.set(_.find(topics, { active: true }), "active", null);
    _.set(_.find(topics, { id: topicID }), "active", true);

    this.setState({
      topics,
      picturePage: 1,
      hasMorePictures: true,
      pictures: []
    })

    this.forceUpdate()

    setTimeout(() => {
      this.loadTopic()
      this.loadPictures()
    }, 160)
  };

  handleSortClicked = (sortID) => {
    let sort = this.state.sort;
    _.set(_.find(sort, { active: true }), "active", null);
    _.set(_.find(sort, { id: sortID }), "active", true);

    this.setState({
      sort,
      picturePage: 1,
      hasMorePictures: true,
      pictures: []
    })

    setTimeout(() => {
      this.loadTopic()
      this.loadPictures()
    }, 160)

    this.forceUpdate()
  };

  handleLinkClick = event => {
    if (isGamedistributionApp()) {
      let href = $(event.target).attr("data-href")
      if (!href) {
        href = $(event.target).parents(".shadow_overlay").attr("data-href")
      }

      event.preventDefault();
      window.parent.postMessage({ event: "handleLinkClick", link: `${href}?platform=gamedistribution` }, "*")
    }
  }

  //-----------------------------------------------------------------------
  // Helpers
  //-----------------------------------------------------------------------
  activeTopic = () => this.state.topics.find(topic => topic.active)
  activeSort = () => this.state.sort.find(sort => sort.active)

  loadTopic = () => {
    if (this.activeTopic().id === "all") {
      this.context.fetch(`/api/unsplash/topics?ids=${encodeURIComponent(_.map(this.state.topics, 'id').join("&"))}&page=${this.state.picturePage}&perPage=${this.state.topics.length}&orderBy=${this.activeSort().id}`).then(response => response.json()).then((json) => {
        this.setState({ topic: { total_photos: _.sumBy(json, 'total_photos') } })
        this.forceUpdate();
      });
    } else {
      this.context.fetch(`/api/unsplash/topics/${this.activeTopic().id}`).then(response => response.json()).then((json) => {
        this.setState({ topic: json })
        this.forceUpdate();
      });
    }
  };

  loadPictures = () => {
    if (is.truthy(this.state.isLoadingPictures)) {
      return
    }

    this.state.isLoadingPictures = true

    if (this.activeTopic().id === "all") {
      this.context.fetch(`/api/unsplash/photos?page=${this.state.picturePage}&perPage=${24}&orderBy=${this.activeSort().id}`).then(response => response.json()).then((json) => {
        this.setState({ picturePage: this.state.picturePage + 1, hasMorePictures: !!this.props.id && is.equal(json.length, 24), pictures: _.concat(this.state.pictures, json) })
        this.forceUpdate();

        _.delay(() => {
          $("#app").perfectScrollbar("update");
        }, 0)

        _.delay(() => {
          this.setState({ isLoadingPictures: false })
          this.forceUpdate();
        }, 160)
      });
    } else {
      this.context.fetch(`/api/unsplash/topics/${this.activeTopic().id}/photos?page=${this.state.picturePage}&perPage=${24}&orderBy=${this.activeSort().id}`).then(response => response.json()).then((json) => {
        this.setState({ picturePage: this.state.picturePage + 1, hasMorePictures: !!this.props.id && is.equal(json.length, 24), pictures: _.concat(this.state.pictures, json) })
        this.forceUpdate();

        _.delay(() => {
          $("#app").perfectScrollbar("update");
        }, 0)

        _.delay(() => {
          this.setState({ isLoadingPictures: false })
          this.forceUpdate();
        }, 160)
      });
    }
  };

  //-----------------------------------------------------------------------
  // Render
  //-----------------------------------------------------------------------
  render() {
    return (
      <div id="topics_component"
        style={{
          "paddingRight": `${this.state.offsetRight}px`
        }}
      >
        <Container id="headline_container">
          <Row>
            <Col>
              <Choose>
                <When condition={!!this.props.id}>
                  <div className="dropdown_container">
                    <h4 className="topic_type float-right">{is.existy(this.state.topic.total_photos) ? `${this.state.topic.total_photos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} puzzles` : ''}</h4>
                    <h1 className="bold">{`${_.capitalize(this.props.id)}`}</h1>
                    <h1>&nbsp;</h1>
                    <h1>category sorted by</h1>
                    <h1>&nbsp;</h1>
                    <Dropdown toggle={() => {}}>
                      <DropdownToggle>
                        <h1>{_.lowerCase(this.activeSort().title)}</h1>
                      </DropdownToggle>
                      <DropdownMenu>
                        <For each="sort" index="idx" of={this.state.sort}>
                          <DropdownItem key={idx}><h4 className={classNames({ active: sort.id === this.activeSort().id })} onClick={this.handleSortClicked.bind(this, sort.id)}>{sort.title}</h4></DropdownItem>
                        </For>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </When>
                <Otherwise>
                  <div className="dropdown_container">
                    <h4 className="topic_type float-right">{is.existy(this.state.topic.total_photos) ? `${this.state.topic.total_photos.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')} puzzles` : ''}</h4>
                    <Dropdown toggle={() => {}}>
                      <DropdownToggle>
                        <h1>{this.activeTopic().title}</h1>
                      </DropdownToggle>
                      <DropdownMenu>
                        <For each="topic" index="idx" of={this.state.topics}>
                          <DropdownItem key={idx}><h4 className={classNames({ active: topic.id === this.activeTopic().id })} onClick={this.handleTopicClicked.bind(this, topic.id)}>{topic.title}</h4></DropdownItem>
                        </For>
                      </DropdownMenu>
                    </Dropdown>
                    <h1>&nbsp;</h1>
                    <h1>puzzles sorted by</h1>
                    <h1>&nbsp;</h1>
                    <Dropdown toggle={() => {}}>
                      <DropdownToggle>
                        <h1>{_.lowerCase(this.activeSort().title)}</h1>
                      </DropdownToggle>
                      <DropdownMenu>
                        <For each="sort" index="idx" of={this.state.sort}>
                          <DropdownItem key={idx}><h4 className={classNames({ active: sort.id === this.activeSort().id })} onClick={this.handleSortClicked.bind(this, sort.id)}>{sort.title}</h4></DropdownItem>
                        </For>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </Otherwise>
              </Choose>
            </Col>
          </Row>
        </Container>

        <Container id="pictures">
          <InfiniteScroll
            pageStart={0}
            loadMore={this.handleBottomReached}
            hasMore={this.state.hasMorePictures}
            loader={<Row key={0}><Col><p className="picture_loader" key={0}>{is.above(this.state.pictures.length, 0) && is.truthy(this.state.hasMorePictures) ? 'Loading puzzles' : ''}</p></Col></Row>}
            useWindow={false}
            getScrollParent={() => document.getElementById("app")}
            threshold={128}
            initialLoad={false}
            >
            <Row>
              <Col xs="12" sm="6" md="4">
                <For each="item" index="idx" of={_.filter(this.state.pictures, (o, i) => (i + 1 - 1) % 3 == 0 )}>
                  {this.pictureContainer(item, idx)}
                </For>
              </Col>
              <Col xs="12" sm="6" md="4">
                <For each="item" index="idx" of={_.filter(this.state.pictures, (o, i) => (i + 1 - 2) % 3 == 0 )}>
                  {this.pictureContainer(item, idx)}
                </For>
              </Col>
              <Col xs="12" sm="6" md="4">
                <For each="item" index="idx" of={_.filter(this.state.pictures, (o, i) => (i + 1) % 3 == 0 )}>
                  {this.pictureContainer(item, idx)}
                </For>
              </Col>
            </Row>
          </InfiniteScroll>
          <If condition={!this.props.id && this.state.pictures.length > 12}>
            <Row>
              <Col xs="12">
                <Button
                  className="btn-lg show_more"
                  color="secondary"
                  tag={LinkComponent}
                  to={`/topics/${this.activeTopic().id}`}
                >
                  Show all puzzles in category
                </Button>
              </Col>
            </Row>
          </If>
        </Container>
      </div>
    );
  }
}

export default withStyles(styles)(TopicsComponent);



// WEBPACK FOOTER //
// ./src/routes/collections/components/TopicsComponent/index.js